import React, { useEffect, useRef, useState } from 'react';
import './WhyUpgrade.css';

const WhyUpgrade: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const features = [
    {
      icon: '/assets/icons/convenience.svg',
      title: 'Convenience',
      description: 'Effortlessly control your home\'s features with your smartphone or voice commands, saving time and simplifying daily tasks.',
      image: 'https://framerusercontent.com/images/suiFmT205UcEXPi8HQWDGBesShc.png?scale-down-to=512&width=1920&height=1080'
    },
    {
      icon: '/assets/icons/security.svg',
      title: 'Security',
      description: 'Enhance your home\'s safety with real-time alerts and remote monitoring, ensuring peace of mind wherever you are.',
      image: 'https://framerusercontent.com/images/aS7y9ppF1XBdgJuuYJtALH3dmBc.jpeg?width=1079&height=1079'
    },
    {
      icon: '/assets/icons/energy.svg',
      title: 'Energy Saving',
      description: 'Cut down on utility bills and reduce your carbon footprint with smart devices that optimize your home\'s energy use.',
      image: 'https://framerusercontent.com/images/g0HUrxRdhBFpBrrgX99a6Oi9OtQ.png?width=800&height=600'
    }
  ];

  return (
    <section className="why-upgrade" ref={sectionRef}>
      <div className="why-upgrade-container">
        <h2 className="why-upgrade-title">Why Upgrade to a Smart Home?</h2>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={`feature-card ${isVisible ? 'animate-in' : 'animate-out'}`}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="feature-image">
                <img src={feature.image} alt={feature.title} />
                <div className="feature-icon">
                  <img src={feature.icon} alt="" />
                </div>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <a href="https://wa.me/+94774641111" className="schedule-btn">
          Schedule a Meeting
        </a>
      </div>
    </section>
  );
};

export default WhyUpgrade;
